
export default {
  components: {
  },
};
